import { render, staticRenderFns } from "./relatorioTemzap.vue?vue&type=template&id=13f8bf28&scoped=true"
import script from "./relatorioTemzap.vue?vue&type=script&lang=js"
export * from "./relatorioTemzap.vue?vue&type=script&lang=js"
import style0 from "./relatorioTemzap.vue?vue&type=style&index=0&id=13f8bf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8bf28",
  null
  
)

export default component.exports